import { Navigate } from "react-router";
import { useAuth } from "../context/authContext";

export const CanGuest = ({ children }) => {
    const { authUser, loading } = useAuth();

    if(loading) {
        return null;
    }

    if(authUser) {
        return <Navigate to="/" />;
    }

    return children;
}